import {createContext as $ehOdT$createContext, useContext as $ehOdT$useContext, useRef as $ehOdT$useRef} from "react";
import $ehOdT$macrostrathyper from "@macrostrat/hyper";
import {useAsyncEffect as $ehOdT$useAsyncEffect, geologyPatternURL as $ehOdT$geologyPatternURL} from "@macrostrat/ui-components";




const $289dfaad57c8b69d$export$f8a3ff1b6bcec62 = (0, $ehOdT$createContext)(null);
const $289dfaad57c8b69d$export$2926ceaa6d8d8b07 = (props)=>{
    const { resolvePattern: resolvePattern, children: children } = props;
    return (0, $ehOdT$macrostrathyper)($289dfaad57c8b69d$export$f8a3ff1b6bcec62.Provider, {
        value: {
            resolvePattern: resolvePattern
        },
        children: children
    });
};
var $289dfaad57c8b69d$export$3d750f4e9f4d0fc8 = /*#__PURE__*/ function(PatternType) {
    PatternType["Vector"] = "vector";
    PatternType["Raster"] = "raster";
    return PatternType;
}($289dfaad57c8b69d$export$3d750f4e9f4d0fc8 || {});
const $289dfaad57c8b69d$var$RasterGeologicPattern = (props)=>{
    const { resolvePattern: resolvePattern } = (0, $ehOdT$useContext)($289dfaad57c8b69d$export$f8a3ff1b6bcec62);
    let { prefix: prefix, backgroundColor: backgroundColor, color: color, width: width, height: height, id: id, name: name, ...rest } = props;
    const patternSize = {
        width: width,
        height: height
    };
    const patternBounds = {
        x: 0,
        y: 0,
        ...patternSize
    };
    const patternID = `${prefix}-${name ?? id}`;
    const maskID = `${patternID}-mask`;
    const ref = (0, $ehOdT$useRef)();
    (0, $ehOdT$useAsyncEffect)(async ()=>{
        const { current: img } = ref;
        if (img == null) return;
        try {
            const uri = await (0, $ehOdT$geologyPatternURL)(id, backgroundColor, color);
            img.crossOrigin = "anonymous";
            img.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", uri);
        } catch (err) {
            console.error(err);
        }
    }, [
        id,
        ref
    ]);
    return (0, $ehOdT$macrostrathyper)("pattern", {
        id: patternID,
        patternUnits: "userSpaceOnUse",
        ...patternSize,
        ...rest
    }, (0, $ehOdT$macrostrathyper)("image", {
        ref: ref,
        ...patternSize
    }));
};
const $289dfaad57c8b69d$var$VectorGeologicPattern = (props)=>{
    const { resolvePattern: resolvePattern } = (0, $ehOdT$useContext)($289dfaad57c8b69d$export$f8a3ff1b6bcec62) ?? {};
    if (resolvePattern == null) return null;
    let { prefix: prefix, backgroundColor: backgroundColor, color: color, width: width = 100, height: height = 100, id: id, name: name, ...rest } = props;
    const patternSize = {
        width: width,
        height: height
    };
    const patternBounds = {
        x: 0,
        y: 0,
        ...patternSize
    };
    const href = resolvePattern(id);
    if (href == null) return null;
    // Compositing if we want to set overlay color
    // let overlayStyles = {}
    // if (color != null) {
    //   overlayStyles = {mixB}
    // }
    const patternID = `${prefix}-${name ?? id}`;
    const maskID = `${patternID}-mask`;
    return (0, $ehOdT$macrostrathyper)("pattern", {
        id: patternID,
        patternUnits: "userSpaceOnUse",
        shapeRendering: "crispEdges",
        ...patternSize,
        ...rest
    }, [
        (0, $ehOdT$macrostrathyper)("g", {
            style: {
                isolation: "isolate"
            }
        }, [
            // Mask, if required
            (0, $ehOdT$macrostrathyper).if(color != null && id != null)("mask", {
                id: maskID
            }, [
                (0, $ehOdT$macrostrathyper)("image", {
                    xlinkHref: href,
                    ...patternBounds
                })
            ]),
            (0, $ehOdT$macrostrathyper).if(backgroundColor != null)("rect", {
                ...patternBounds,
                fill: backgroundColor
            }),
            // Render a masked colored image
            (0, $ehOdT$macrostrathyper).if(color != null)("rect", {
                ...patternBounds,
                fill: color,
                mask: `url(#${maskID})`
            }),
            // Or render the image as normal
            (0, $ehOdT$macrostrathyper).if(id != null && color == null)("image", {
                xlinkHref: href,
                ...patternBounds
            })
        ])
    ]);
};
const $289dfaad57c8b69d$export$9e9c2df1189db669 = (props)=>{
    let { type: type = "vector", invert: invert, ...rest } = props;
    if (invert ?? false) {
        rest.color = props.backgroundColor;
        rest.backgroundColor = props.color;
    }
    switch(type){
        case "vector":
            return (0, $ehOdT$macrostrathyper)($289dfaad57c8b69d$var$VectorGeologicPattern, rest);
        case "raster":
            return (0, $ehOdT$macrostrathyper)($289dfaad57c8b69d$var$RasterGeologicPattern, rest);
    }
};


//# sourceMappingURL=patterns.58a423e0.js.map
